module.exports = __webpack_public_path__ + "img/ColoredSpace2.bc064186.jpg";